import { useQuery } from '@apollo/client';

import { get as getUser, isPoweruser } from 'js/lib/user';

import PartnerAdminMembershipsQuery from 'bundles/account-settings/queries/PartnerAdminMembershipsQuery.graphql';
import type {
  PartnerAdminMembershipsQueryQuery,
  PartnerAdminMembershipsQueryQueryVariables,
} from 'bundles/account-settings/queries/__generated__/PartnerAdminMembershipsQuery';
import { DATA_COORDINATOR, INSTRUCTOR, PARTNER_ADMIN, TEACHING_STAFF } from 'bundles/common/constants/PartnerRoles';

const ALLOWED_PARTNER_ROLES: string[] = [PARTNER_ADMIN, INSTRUCTOR, DATA_COORDINATOR, TEACHING_STAFF];

export const useIsRemindersPreferenceVisible = (): boolean => {
  const isPowerUser = isPoweruser();

  const { data, loading } = useQuery<PartnerAdminMembershipsQueryQuery, PartnerAdminMembershipsQueryQueryVariables>(
    PartnerAdminMembershipsQuery,
    {
      variables: { userId: `${getUser().id}` },
      skip: isPowerUser,
      errorPolicy: 'all',
      context: { clientName: 'gatewayGql' },
    }
  );

  if (isPowerUser) {
    return true;
  }

  if (loading) {
    return false;
  }

  const memberships = data?.NaptimeQueries.PartnerMembershipsV1Resource.findAllByUser?.elements ?? [];
  return memberships.some((membership) => !!membership && ALLOWED_PARTNER_ROLES.includes(membership.role));
};
